<!--招投标详情-->
<template>
  <div class="bidding-details-container">
    <header-index/>
    <div class="bidding-details-content">
      <div class="bidding-details-breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/ServiceCentre/serviceCloud?pName='+cityList.abridge+'企服务云' }">
            {{ cityList.abridge }}企服务云
          </el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/enterpriseSearch/index' }">企业查询</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/enterpriseSearch/bidding' }">招投标</el-breadcrumb-item>
          <el-breadcrumb-item>详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="bidding--details">
        <p class="bidding-title">{{ biddingDetail.title }}</p>
        <div class="bidding-menu">
          <p>
            <label>
              <span class="bidding-small-title">项目编号：</span>
              <span class="details-info">2203-500230-04-04-679350</span>
            </label>
            <label>
              <span class="bidding-small-title">招采单位：</span>
              <span class="details-info">丰都县公路事务中心</span>
            </label>
            <label>
              <span class="bidding-small-title">代理单位：</span>
              <span class="details-info">中轩（重庆）建设监理有限公司</span>
            </label>
          </p>
          <p>
            <label>
              <span class="bidding-small-title">预算金额：</span>
              <span class="details-info">****万</span>
            </label>
            <label>
              <span class="bidding-small-title">联系方式：</span>
              <span class="details-info">代理单位  向老师  187****6923</span>
            </label>
          </p>
          <p>
            <label>
              <span class="bidding-small-title">发布时间：</span>
              <span class="details-info">202-12-31</span>
            </label>
            <label>
              <span class="bidding-small-title">投标截止时间：</span>
              <span class="details-info">2023-1-31 09:30</span>
            </label>
          </p>
        </div>
        <div v-html="contentHtml"></div>
      </div>
    </div>
    <home_footer/>
    <Hang/>
  </div>
</template>
<script>
import HeaderIndex from "@/components/header/headerIndex";
import Hang from "@/components/Hang/Hangs";
import Home_footer from "@/components/footer/home_footer";
import cityJson from "@/static/cityJson.json";
import {getBiddingDetails} from '@/api/enterprise_searchApi'

export default {
  name: "biddingDetails",
  components: {Home_footer, Hang, HeaderIndex},
  data() {
    return {
      cid: 0,
      cityList: {},
      id: 0,
      biddingDetail: {},
      contentHtml: '<html><body><div><span>招标公告</span><p><span>我公司现对<u>中冶天工洋浦产城融合安居工程及配套设施项目（一期）施工二标段室外管网及绿化工程<span lang="EN-US">1</span>标段</u>专业进行公开分包招标，现诚邀投标人前来参加本次招标活动。 </span></p><p><span lang="EN-US">一、 </span><span>招标名称：<u>中冶天工洋浦产城融合安居工程及配套设施项目（一期）施工二标段室外管网及绿化工程<span lang="EN-US">1</span>标段</u></span><span>专业分包</span><span>。 </span></p><p><span lang="EN-US">二、 </span><span>招标编号：</span><span lang="EN-US">201305-2020-0738-</span><span>二分<span lang="EN-US">-ZB017-01</span></span><span>。 </span></p><p><span lang="EN-US">三、 </span><span>工程概况及招标范围 </span></p><p><span lang="EN-US">（一）</span><span>工程概况 </span></p><p><span>工程名称：</span><span>中冶天工</span><span>洋浦产城融合安居工程及配套设施项目（一期）施工二标段室外管网及绿化工程<span lang="EN-US">1</span>标段专业分包</span> </p><p><span>建设地点：海南省儋州市洋浦经济开发区 </span></p><p><span>总用地面积：<span lang="EN-US">10.25</span>万平方米 </span></p><p><span>总建筑面积：<span lang="EN-US">30.01</span>万平方米 </span></p><p><span>工程结构类型：<span lang="EN-US">PC</span>装配式建筑 </span></p><p><span>楼高及层数</span><span>：地上<span lang="EN-US">18</span>层（首层层高<span lang="EN-US">4.2m</span>，标准层层高<span lang="EN-US">2.9m</span>）、地下<span lang="EN-US">1</span>层（层高<span lang="EN-US">5.4m</span>）</span> </p><p><span lang="EN-US">（二）</span><span>招标范围 </span></p><p><span>该专业工程共<span lang="EN-US">2</span>个标段，本次招标<span lang="EN-US">2</span>标段， </span></p><p><span>本次招标洋浦产城融合安居工程及配套设施项目（一期）施工二标段室外管网及绿化工程<span lang="EN-US">1</span>标段：<span lang="EN-US">1#</span>、<span lang="EN-US">2#</span>、<span lang="EN-US">3#</span>、<span lang="EN-US">4#</span>、<span lang="EN-US">5#</span>、<span lang="EN-US">6#</span>、<span lang="EN-US">7#</span>、<span lang="EN-US">8#</span>、<span lang="EN-US">9#</span>楼、<span lang="EN-US">TCL1#</span>楼图纸范围内的室外管网及绿化工程。 </span></p><p><span>施工内容：洋浦产城融合安居工程及配套设施项目（一期）施工二标段室外管网及绿化工程，楼地面水泥砂浆找平层，楼地面石材铺贴，墙面砖铺设，地坪砼浇筑，细石混凝土，环氧自流平地面，石膏板吊顶，铝合金扣板吊顶，天棚抹灰，刮腻子，内墙天棚涂料，外墙涂料，扶手、栏杆，道路整形、栽植树木，混凝土浇注、钢筋制安、砌筑、预埋件（预埋螺栓）制安，电气设备、强电弱电、给排水等预留预埋、布管、穿线、设备安装、调试、预留洞口封堵等图纸内全部工作内容。具体施工内容及明细见招标工程量清单明细表。 </span></p><p><span lang="EN-US">四、 </span><span>对投标人的资格要求 </span></p><p><span>（一）<u>投标人应有符合本工程要求的</u></span><span>建筑机电安装工程专业承包三级</span><span>及以上资质。信誉良好，</span><span>施工能力强、业绩突出，并在人员、设备、资金等方面具有相应的实力，</span><span>具有垫资能力（垫资至工程施工完毕）</span><span>。投标人应是一般纳税人，能够开具增值税专用发票，持有建筑施工企业营业执照、资质证书、安全生产许可证、开户许可证、法人身份证明及授权委托书（如有授权委托书）</span><span>；</span> </p><p><span>（二）投标人须是中冶集团的合格分包商；</span> </p><p><span>（三）参加本工程投标的投标人代表，须是单位的法定代表人或其委托代理人，投标书中须有相关的证明文件及法人授权委托书； </span></p><p><span>（四）投标人承诺的工程质量、安全文明、工期必须达到招标人的要求； </span></p><p><span>（五）投标人须接受招标文件规定的各项条件，并在投标文件中作出实质性响应； </span></p><p><span>（六）资格预审合格的投标人不递交投标文件，将在对分包人考核中降低信誉等级，累计两次以上列入集团公司黑名单； </span></p><p><span>（七）本次招标范围内工程不允许再次转包或分包，否则招标人有权重新选择中标人； </span></p><p><span>（八）投标人不得存在下列情形 </span></p><p><span lang="EN-US">1）</span><span>近期内发生重大质量、安全事故的； </span></p><p><span lang="EN-US">2）</span><span>影响企业声誉，造成重大经济损失的；</span> </p><p><span>（九）本次招标不接受联合体形式投标。 </span></p><p><span lang="EN-US">五、 </span><span>招标文件的获取 </span></p><p><span lang="EN-US">（一）</span><span>凡有意投标者，请于</span><span lang="EN-US">2023</span><span>年</span><span lang="EN-US">1</span><span>月</span><span lang="EN-US">13</span><span>日</span><span lang="EN-US">9</span><span>时前（如有变化，以电商平台最终时间为准），登录中国五矿集团有限公司采购电子商务平台（<span lang="EN-US">https://ec.minmetals.com.cn</span>，以下简称电商平台）</span><span lang="EN-US">进行</span><span lang="EN-US">网上报名</span><span lang="EN-US">。</span> </p><p><span lang="EN-US">（二）</span><span>招标文件的获取：网络报名成功后，将对其发放招标文件，投标人可登录电商平台</span><span lang="EN-US">自行下载招标文件，并根据招标文件的要求在投标截止日前进行网上投标。</span> </p><p><span lang="EN-US">六、</span><span>标书费和投标保证金 </span></p><p><span>投标人在投标截止时间前将标书费<span lang="EN-US">1000 </span>元以单位名义现汇缴纳至招标人财务账户，并将银行转账回执单作为投标文件（商务标）中的附件上传至五矿电商平台，未缴纳的将不能参与投标。</span> </p><p><span>账户名称：</span><span>中冶天工集团有限公司</span> </p><p><span>开户行：</span><span>建行天津滨海临空支行</span> </p><p><span>账号：</span><span lang="EN-US">12001785600052501895</span><span>； </span></p><p><span>汇款时请注明</span><span>：</span><span>天津有限洋浦产城融合</span><span>室外管网及绿化工程<span lang="EN-US">1</span>标段</span><span>标书费<span lang="EN-US">2021124055</span></span> </p><p><span lang="EN-US">七、 </span><span>投标截止时间及开标时间： </span></p><p><span lang="EN-US">（一）</span><span>投标截止时间：</span><span lang="EN-US">2023</span><span>年</span><span lang="EN-US">1</span><span>月</span><span lang="EN-US">13</span><span>日</span><span lang="EN-US">9</span><span>时（北京时间） </span></p><p><span lang="EN-US">（二）</span><span>开标时间：</span><span lang="EN-US">2023</span><span>年</span><span lang="EN-US">1</span><span>月</span><span lang="EN-US">13</span><span>日</span><span lang="EN-US">9</span><span>时（北京时间） </span></p><p><span>如有变化，以电商平台最终时间为准。 </span></p><p><span lang="EN-US">八、 </span><span>招标人联系方式 </span></p><p><span>招标联系人：</span><span>侯娟娟</span> </p><p><span>联系电话：</span><span lang="EN-US">15122196745</span> </p><p><span>电子邮箱：</span><span lang="EN-US">tjyxjyysb@ctmcc.com.cn</span> </p><p></p><p></p><p><span>招标人：</span><span>中冶天工集团天津有限公司经营预算部</span> </p><p> <span>日 期：<span lang="EN-US">2023</span>年<span lang="EN-US">1</span>月<span lang="EN-US">6</span>日 </span></p><div><a filelink="90df92c8563200e09d6a1cf14df05472" href="https://ec.minmetals.com.cn/open/register/download?fjbh=2023010355305" rel="noreferrer">洋浦产城融合安居工程及配套设施项目（一期）施工二标段室外管网及绿化工程1标段专业分包--招标公告.pdf</a><a data="90df92c8563200e09d6a1cf14df05472" href="http://www.bidizhaobiao.com/file/20230107/2023-01-07/DX000027/1673059631362.pdf" style="display:none">洋浦产城融合安居工程及配套设施项目（一期）施工二标段室外管网及绿化工程1标段专业分包--招标公告.pdf</a></div><br/></div></body></html><div style="display:none;" class="richTextFetch"><div filemd5="90df92c8563200e09d6a1cf14df05472"></div></div>'
    }
  },
  methods: {
    getBiddingDetail() {
      getBiddingDetails({id: this.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.biddingDetail = res.content[0];
          console.log(res.content[0]);
        }
      })
    }
  },
  mounted() {
    this.getBiddingDetail();
  },
  beforeMount() {
    this.id = this.$route.query.id;
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    if (sessionStorage.getItem('setPositioning')) {
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    } else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name) {
          this.cityList = li;
        }
      }
    }
  }
}
</script>
<style scoped>
.bidding-details-container >>> .bidding-details-content .bidding-details-breadcrumb .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-family: 'SourceHanSansCN';
  color: #666666;
}

.bidding-details-container >>> .bidding-details-content .bidding-details-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.bidding-details-container >>> .bidding-details-content .bidding-details-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.bidding-details-container >>> .bidding-details-content .bidding-details-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.bidding-details-container >>> .bidding-details-content .bidding-details-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}

.bidding-details-container >>> .bidding-details-content .bidding-details-breadcrumb .el-breadcrumb {
  font-size: 14px;
  line-height: normal;
}

.bidding-details-container >>> .bidding-details-content .bidding-details-breadcrumb .el-breadcrumb__inner a,
.bidding-details-container >>> .bidding-details-content .bidding-details-breadcrumb .el-breadcrumb__inner.is-link {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}
</style>
<style scoped lang="scss">
.bidding-details-container {
  background: #E7E9F5;

  .bidding-details-content {
    padding: 10px 18%;
    min-width: 76rem;
    background: #E7E9F5;
    .bidding--details {
      margin-top: 10px;
      padding: 30px;
      background: #FFFFFF;

      .bidding-title {
        font-size: 36px;
        font-family: 'SourceHanSansCN';
        color: #333333;
        font-weight: 600;
        margin-block-start: 0px;
      }

      .bidding-menu {
        .bidding-small-title {
          color: #999999;
          font-size: 14px;
          font-family: 'SourceHanSansCN';
        }

        .details-info {
          color: #333333;
          font-size: 14px;
          font-family: 'SourceHanSansCN';
          padding-right: 60px;
        }
      }

    }
  }
}
</style>